import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  action: "insert",
  contrNo: null,
  siteNo: null,
  SEQ: null,
  taskCodeListId: null,
  taskCodeId: null,
  detailedCmt: null,
  submDate: null,
  apprDate: null,
  // 1: null,
  // 2: null,
  // 3: null,
  // 4: null,
  // 5: null,
  // 6: null,
  // 7: null,
  // 9: null,
  cmt: null,
  claimDate: null,
  claim: null,
};

export const IRBTaskSlice = createSlice({
  name: "IRBTask",
  initialState,
  reducers: {
    updateAction: (state, action) => {
      return {
        ...state,
        action: action.payload.action,
      };
    },

    updateSiteNo: (state, action) => {
      return {
        ...state,
        siteNo: action.payload.siteNo,
      };
    },

    init: (state, action) => {
      const taskCodeListId = state.taskCodeListId;

      return {
        ...initialState,
        taskCodeListId: taskCodeListId,
      };
    },

    updateAll: (state, action) => {
      return {
        ...action.payload,
      };
    },

    updateClaimDate: (state, action) => {
      return {
        ...state,
        claimDate: action.payload.claimDate,
      };
    },

    updateClaim: (state, action) => {
      return {
        ...state,
        claim: action.payload.claim,
      };
    },

    updateTaskCodeListId: (state, action) => {
      return {
        ...state,
        taskCodeListId: action.payload.taskCodeListId,
      };
    },

    updateTaskCodeId: (state, action) => {
      return {
        ...state,
        taskCodeId: action.payload.taskCodeId,
      };
    },

    updateDetailedCmt: (state, action) => {
      return {
        ...state,
        detailedCmt: action.payload.detailedCmt,
      };
    },

    updateSubmDate: (state, action) => {
      return {
        ...state,
        submDate: action.payload.submDate,
      };
    },

    updateApprDate: (state, action) => {
      return {
        ...state,
        apprDate: action.payload.apprDate,
      };
    },

    // update1: (state, action) => {
    //   return {
    //     ...state,
    //     1: action.payload["1"],
    //   };
    // },

    // update2: (state, action) => {
    //   return {
    //     ...state,
    //     2: action.payload["2"],
    //   };
    // },

    // update3: (state, action) => {
    //   return {
    //     ...state,
    //     3: action.payload["3"],
    //   };
    // },

    // update4: (state, action) => {
    //   return {
    //     ...state,
    //     4: action.payload["4"],
    //   };
    // },

    // update5: (state, action) => {
    //   return {
    //     ...state,
    //     5: action.payload["5"],
    //   };
    // },

    // update6: (state, action) => {
    //   return {
    //     ...state,
    //     6: action.payload["6"],
    //   };
    // },

    // update7: (state, action) => {
    //   return {
    //     ...state,
    //     7: action.payload["7"],
    //   };
    // },

    // update9: (state, action) => {
    //   return {
    //     ...state,
    //     9: action.payload["9"],
    //   };
    // },

    updateCmt: (state, action) => {
      return {
        ...state,
        cmt: action.payload.cmt,
      };
    },
  },
});

export const {
  updateAction,
  updateSiteNo,
  init,
  updateAll,
  updateClaimDate,
  updateTaskCodeId,
  updateDetailedCmt,
  updateSubmDate,
  updateApprDate,
  // update1,
  // update2,
  // update3,
  // update4,
  // update5,
  // update6,
  // update7,
  // update9,
  updateCmt,
  updateTaskCodeListId,
  updateClaim,
} = IRBTaskSlice.actions;

export default IRBTaskSlice.reducer;
